import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=51262936&scoped=true"
import script from "./Register.js?vue&type=script&lang=js&external"
export * from "./Register.js?vue&type=script&lang=js&external"
import style0 from "./Register.css?vue&type=style&index=0&id=51262936&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51262936",
  null
  
)

export default component.exports